import { VueCharts, mixins } from 'vue-chartjs';
import { getGear } from '@/services/analysis.js';
const { reactiveProp } = mixins;

const lineChartData = {
  labels: [],
  datasets: [{
    label: '',
    borderColor: '#17375E',
    backgroundColor: '#17375E',
    data: [],
    fill: false,
    datalabels: {
      formatter() {
        return '';
      }
    }
  },
  {
    label: '',
    borderColor: '#0078D7',
    backgroundColor: '#0078D7',
    data: [],
    fill: false,
    datalabels: {
      formatter() {
        return '';
      }
    }
  }]
};

export default {
  extends: VueCharts.Line,
  mixins: [reactiveProp],
  props: [
    'chartData',
    'showGears',
    'label1',
    'label2'
  ],
  watch: {
    chartData: {
      handler(newData) {
        if (newData) this.draw();
      }
    },
    showGears: {
      handler(newData) {
        this.draw();
      }
    },
    label1: {
      handler(newData) {
        if (newData) this.draw();
      }
    },
    label2: {
      handler(newData) {
        if (newData) this.draw();
      }
    }
  },
  mounted() {
    this.addPlugin({
      beforeDraw(chartInstance) {
        const ctx = chartInstance.chart.ctx; // eslint-disable-line prefer-destructuring
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
      }
    });

    if (this.chartData) this.draw();
  },
  methods: {
    draw() {
      // clear out old
      lineChartData.datasets[0].data = [];
      lineChartData.datasets[1].data = [];
      lineChartData.labels = [];

      lineChartData.datasets[0].label = this.label1;
      lineChartData.datasets[1].label = this.label2;
      const useGears = this.showGears;
      // now calculate
      JSON.parse(JSON.stringify(this.chartData)).forEach(year => {
        lineChartData.datasets[0].data.push(
          year[0] ? 
            (useGears ? getGear(year[0].averageScore) : Math.round(parseFloat(year[0].averageScore))) : 
            null
        );
        lineChartData.datasets[1].data.push(
          year[1] ? 
            (useGears ? getGear(year[1].averageScore) : Math.round(parseFloat(year[1].averageScore))) : 
            null
        );
        lineChartData.labels.push((year[0] || year[1]).year);
      });

      this.renderChart(lineChartData, {
        responsive: false,
        maintainAspectRatio: true,
        layout: {
          padding: {
            right: 100
          }
        },
        elements: {
          line: {
            tension: 0
          }
        },
        legend: {
          position: 'right',
          labels: {
            usePointStyle: true
          }
        },
        spanGaps: true,
        title: {
          display: true,
          text: `${useGears ? 'Gears' : 'Scores'} - ${this.label1} vs ${this.label2}`,
          fontStyle: 'bold',
          fontSize: 24
        },
        scales: {
          xAxes: [
            {
              ticks: {
                display: true,
                fontStyle: 'bold',
                fontColor: '#333333',
                fontSize: 12,
                autoSkip: false
              },
              gridLines: {
                display: true,
                color: '#aaaaaa',
                lineWidth: 1,
                drawOnChartArea: true,
                borderDashOffset: -10
              },
              scaleLabel: {
                display: true,
                labelString: 'Year',
                fontStyle: 'bold',
                fontColor: '#333333',
                fontSize: 16
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                display: true,
                min: useGears ? 1 : 0,
                max: useGears ? 4 : 100,
                stepSize: useGears ? 1 : 10,
                fontStyle: 'bold',
                fontColor: '#333333',
                fontSize: 12
              },
              gridLines: {
                display: true,
                color: '#aaaaaa',
                lineWidth: 1,
                drawOnChartArea: true,
                borderDashOffset: -10
              },
              scaleLabel: {
                display: true,
                fontStyle: 'bold',
                fontColor: '#333333',
                fontSize: 16,
                labelString: `Average ${this.showGears ? 'Gear' : 'Score'}`
              }
            }
          ]
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/graphs/ScoreGearYearLine.js